import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SessionItems } from 'app/enums/constants.enum';
import { ModulesDescription } from 'app/enums/modules-description.enum';
import { CaseAdvancedFilterData } from 'app/models/cases/cases-advanced-filter.module';
import { Item } from 'app/models/item.inferface';
import { MVLocalStorageService } from 'app/services/mv-local-storage.service';

@Component({
  selector: 'app-case-advanced-filters',
  templateUrl: './case-advanced-filters.component.html',
  styleUrls: ['./case-advanced-filters.component.scss']
})
export class CaseAdvancedFiltersComponent implements OnInit {  
  @Input() searchFormCases: UntypedFormGroup;
  @Input() searchFormAlert: UntypedFormGroup;
  @Input() modules: Item[] = [];
  @Input() statusData: Item[] = [];
  @Input() sourcesData: Item[] = [];
  @Input() resolutionsData: Item[] = [];
  @Input() criticalitiesData: Item[] = [];
  @Input() currentModule: Item;
  @Input() caseTypes: Item[] = [];
  @Input() progressBar: boolean = false;
  
  @Output() setFilters: EventEmitter<CaseAdvancedFilterData> = new EventEmitter<CaseAdvancedFilterData>();

  modulesDescription = ModulesDescription;
  modulesForm: UntypedFormGroup;
  textFiltersMaxLength = 250;

  constructor(
    private formBuilder: UntypedFormBuilder,
  ) {
    this.modulesForm = this.formBuilder.group({
      moduleSelect: [[], Validators.required],
      moduleDescription: ['']
    });

    this.modulesForm.get('moduleSelect').valueChanges.subscribe(values => {
      if(this.modules?.length > 0){
        this.modulesForm.get('moduleDescription').setValue(this.modules?.find(m => m?.id == values)?.description);
      }
    });

    // console.log('initialize modulesForm');
    // console.log(this.modulesForm);
  }

  ngOnChanges(changes){
    // console.log(changes);
    if(!this.modulesForm?.get('moduleSelect').value || this.modulesForm?.get('moduleSelect').value?.length < 1){
      this.modulesForm?.get('moduleSelect').setValue(this.currentModule?.id ?? null);
    }

    if(this.modules?.length > 0){
      this.modulesForm?.get('moduleDescription').setValue(this.modules?.find(m => m?.id == this.modulesForm?.get('moduleSelect').value)?.description);
    }
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(){
  }

  clearFilters() {
    if(this.modulesForm.get('moduleDescription').value == ModulesDescription.Cases){
      this.searchFormCases.reset();
      let dataFilter: CaseAdvancedFilterData = {
        module: {id: this.modulesForm.get('moduleSelect').value, description: this.modulesForm.get('moduleDescription').value},
        filter: this.searchFormCases.value
      }
      this.setFilters.emit(dataFilter);
    }else if(this.modulesForm.get('moduleDescription').value == ModulesDescription.Alerts){
      this.searchFormAlert.reset();
      let dataFilter: CaseAdvancedFilterData = {
        module: {id: this.modulesForm.get('moduleSelect').value, description: this.modulesForm.get('moduleDescription').value},
        filter: this.searchFormAlert.value
      }
      this.setFilters.emit(dataFilter);
    }
  }

  aplyFilters(): void {
    MVLocalStorageService.setSessionItem(SessionItems.caselist_dynamicFiltersApplied, false);
    if(this.modulesForm.get('moduleDescription').value == ModulesDescription.Cases){
      let dataFilter: CaseAdvancedFilterData = {
        module: {id: this.modulesForm.get('moduleSelect').value, description: this.modulesForm.get('moduleDescription').value},
        filter: this.searchFormCases.value
      }
      this.setFilters.emit(dataFilter);
    }else if(this.modulesForm.get('moduleDescription').value == ModulesDescription.Alerts){
      let dataFilter: CaseAdvancedFilterData = {
        module: {id: this.modulesForm.get('moduleSelect').value, description: this.modulesForm.get('moduleDescription').value},
        filter: this.searchFormAlert.value
      }
      this.setFilters.emit(dataFilter);
    }
  }

}
